<section class="panel placeholder" data-testid="view-live">
  <h2>Live</h2>
  <p>
    Record from the microphone (or the built-in test generator) and watch the waveform, spectrum and
    spectrogram in real time.
  </p>
  <p class="todo">Coming in milestone M2.</p>
</section>

<style>
  .todo {
    color: var(--muted);
    font-style: italic;
  }
</style>
